export const brand = "Maciek Niemczyk Musiker und Programmierer";
